import React from 'react';
import ReactRailsUJS from 'react_ujs';
import { ReactQueryProvider } from '@/utils/ReactQuery';

const ReactQueryRailsWrapper = ({ original_component, original_props }) => {
  const Component = ReactRailsUJS.getConstructor(original_component);

  return (
    <ReactQueryProvider>
      <Component {...original_props} />
    </ReactQueryProvider>
  );
};

export default ReactQueryRailsWrapper;
